import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW, POPUP_SEARCH_PARAMS, DETAIL_FORM } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.selectedRow = SELECTED_ROW();
		state.popupSearchParams = POPUP_SEARCH_PARAMS();
		state.detailForm = DETAIL_FORM();
		state.powTourRgstScrId = '';
		state.isSaved = false;
		state.isPqyStaff = false;
		state.isPqyReviewer = false;
		state.isPqyAdmin = false;
		state.isPqyLs = false;
		state.sndStList = [];
		state.powLnList = [];
		state.resultList = [];
		state.pgsStList = [];
		state.mdvRplList = [];
		state.rmkHistory = [];
		state.rfpInfo = new Map();
		state.rcptInfo = new Map();
	},
	[types.POPUP_INIT]: state => {
		state.detailForm = DETAIL_FORM();
		state.detailForm.powImg1File = {};
		state.detailForm.powImg1FileDb = {};
		state.detailForm.powImg2File = {};
		state.detailForm.powImg2FileDB = {};
		state.isSaved = false;
		state.rfpInfo = new Map();
		state.rcptInfo = new Map();
		state.rfpBcInfo = new Map();
		state.rcptBcInfo = new Map();
		state.rmkHistory = [];
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.SELECTED_ROW]: (state, { key, value }) => {
		state.selectedRow[key] = value;
	},
	[types.DETAIL_FORM]: (state, { key, value }) => {
		state.detailForm[key] = value;
	},
	[types.POPUP_SEARCH_PARAMS]: (state, { key, value }) => {
		state.popupSearchParams[key] = value;
	}
};
